<template>
  <div class="app-container">
    <div class="main">
      <el-row
        :gutter="20"
        style="padding-top: 20px; margin-left: 0; margin-right: 0"
      >
        <el-col :xs="24">
          <el-card>
            <el-tabs v-model="activeTab">
              <el-tab-pane label="全部类型" name="all">
                <div style="display: flex">
                  <div
                    v-show="!isFold"
                    style="width: 400px"
                    class="message-list-container"
                  >
                    <div style="padding: 10px; display: flex">
                      <div style="padding-right: 10px; line-height: 36px">
                        <el-checkbox
                          :indeterminate="isIndeterminate"
                          v-model="checkAll"
                          @change="handleCheckAllChange"
                        ></el-checkbox>
                      </div>
                      <el-button
                        size="small"
                        :disabled="!checkedMessage.length > 0"
                        @click="handleCheckedDelete"
                        >删除</el-button
                      >
                      <el-button
                        size="small"
                        :disabled="!checkedMessage.length > 0"
                        @click="handleCheckedHasRead"
                        >标记已读</el-button
                      >
                      <el-button size="small" @click="handleCheckedHasReadAll">全部已读</el-button>
                      <el-button size="small" @click="handleCheckedDeleteAll">全部删除</el-button>
                      <div
                        style="
                          line-height: 36px;
                          padding-left: 10px;
                          font-size: 26px;
                          cursor: pointer;
                        "
                      >
                        <i class="el-icon-s-fold" @click="isFold = !isFold"></i>
                      </div>
                    </div>
                    <div class="message-list">
                      <ul class="items">
                        <li
                          v-for="item in messageData"
                          :key="item.id"
                          class="item"
                          style="padding: 12px 10px"
                        >
                          <div style="display: flex">
                            <div style="padding-right: 10px; line-height: 36px">
                              <el-checkbox
                                v-model="item.checked"
                                @change="handleCheckedChange($event, item.id)"
                              ></el-checkbox>
                            </div>
                            <div
                              style="flex-grow: 1; padding-right: 20px"
                              class="message-item-content"
                              :class="{ new: item.state === '1' }"
                              @click="detail(item)"
                            >
                              <h5>{{ item.title }}</h5>
                              <i>{{ item.sendTime }}</i>
                            </div>
                            <div
                              class="destroy"
                              style="line-height: 38px"
                              @click="delMessage(item.id)"
                            >
                              <i class="el-icon-delete"></i>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <el-pagination
                      layout="total, sizes, prev, pager, next"
                      :page-sizes="[10, 20, 50, 100]"
                      :total="total"
                      :page-size="listQuery.limit"
                      @current-change="handleCurrentChange"
                      style="margin-top: 10px"
                    >
                    </el-pagination>
                  </div>
                  <div v-show="isFold">
                    <div
                      style="
                        line-height: 36px;
                        padding-left: 10px;
                        font-size: 26px;
                        cursor: pointer;
                      "
                    >
                      <i class="el-icon-s-unfold" @click="isFold = !isFold"></i>
                    </div>
                  </div>
                  <div
                    style="min-height: 500px; flex-grow: 1"
                    class="message-detail"
                  >
                    <div class="message-title">
                      <h4 style="font-size: 18px">
                        {{ messageDetail.title }}
                      </h4>
                    </div>
                    <h5 class="message-info" style="font-size: 14px">
                      <span class="message-publish-time"
                        >发布于 {{ messageDetail.sendTime }}</span
                      >
                      <span class="message-category"> | 通知</span>
                    </h5>
                    <el-divider></el-divider>
                    <div
                      class="message-content"
                      v-html="messageDetail.content"
                    ></div>
                  </div>
                </div>
              </el-tab-pane>
              <!-- <el-tab-pane label="通知" name="notice"> 通知 </el-tab-pane>
              <el-tab-pane label="成绩" name="achievement"> 成绩 </el-tab-pane>
              <el-tab-pane label="账号" name="account"> 账号 </el-tab-pane> -->
            </el-tabs>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { myMessageService } from "@/api/messages";

export default {
  data() {
    return {
      activeTab: "all",

      isFold: false, // 是否折叠
      checkAll: false, // 全选
      checkedMessage: [], // 选中的
      isIndeterminate: false,

      tableSize: "",
      messageData: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        keywords: undefined,
      },
      // 消息详情
      messageDetail: {},
    };
  },
  watch: {
    // 监听路由对象中的变化
    $route: {
      handler: function () {
        const id = this.$route.params && this.$route.params.id;

        this.getMyMessageById(id);
        // 已读
        this.messageData.find((d) => d.id === id).state = "2";
      },
      // 设置为深度监听
      deep: true,
    },
  },
  created() {
    // const id = this.$route.params && this.$route.params.id;
    // console.log(id);
    this.getList();
  },
  methods: {
    // 获取消息列表
    getList() {
      this.listLoading = true;

      myMessageService
        .getMyMessagePageList({
          // title: this.listQuery.keywords,
          skipCount: (this.listQuery.page - 1) * this.listQuery.limit,
          maxResultCount: this.listQuery.limit,
        })
        .then((res) => {
          this.messageData = res.items.map((item) => {
            return Object.assign(item, { checked: false });
          });

          this.total = res.totalCount;

          // 默认第一项为选中
          if (res.items.length > 0) {
            const msgId = res.items[0].id;
            this.getMyMessageById(msgId);
          }

          this.listLoading = false;
          // 清除选中
          this.checkedMessage = [];
          this.isIndeterminate = false;
        });
    },
    // 详细
    detail(row) {
      this.getMyMessageById(row.id);
      // 已读
      this.messageData.find((d) => d.id === row.id).state = "2";
    },
    getMyMessageById(id) {
      myMessageService.getMyMessageById(id).then((res) => {
        this.messageDetail = res;

        // 未读状态 - 标记为已读
        if (res.state) {
          myMessageService.updateHasRead([res.id]).then(() => {
            //row.state = "2";
          });
        }
      });
    },
    // 删除
    delMessage(id) {
      // const index = this.messageData.findIndex((d) => d.id === id)
      // this.messageData.splice(index, 1)

      this.$confirm("此操作将永久删除该消息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        myMessageService.deleteMyMessage(id).then(() => {
          this.messageDetail = undefined;
          // 重新加载
          this.getList();
        });
        // this.$message({
        //   type: 'success',
        //   message: '删除成功!'
        // })
      });
    },
    // 选中删除
    handleCheckedDelete() {
      this.$confirm("此操作将永久删除选中消息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const ids = this.checkedMessage;
        myMessageService.deleteMyMessages(ids).then(() => {
          this.messageDetail = undefined;
          // 重新加载
          this.getList();
        });
      });
    },
    // 删除全部
    handleCheckedDeleteAll() {
      this.$confirm("此操作将永久删除全部消息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        myMessageService.deleteMyMessageAll().then(() => {
          this.messageDetail = undefined;
          // 重新加载
          this.getList();
        });
      });
    },
    // 选中标记已读
    handleCheckedHasRead() {
      const ids = this.checkedMessage;
      myMessageService.updateHasRead(ids).then(() => {
        // 重新加载
        this.getList();
      });
    },
    // 全部标记已读
    handleCheckedHasReadAll() {
      myMessageService.updateHasReadAll().then(() => {
        // 重新加载
        this.getList();
      });
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.listQuery.page = val;
      this.getList();
    },
    handleCheckAllChange(val) {
      this.checkedMessage = val ? this.messageData.map((d) => d.id) : [];
      this.messageData.forEach((item) => {
        item.checked = val;
      });
      this.isIndeterminate = false;
    },
    handleCheckedChange(value, id) {
      if (value) {
        this.checkedMessage.push(id);
      } else {
        const index = this.checkedMessage.findIndex((d) => d === id);
        this.checkedMessage.splice(index, 1);
      }

      let checkedCount = this.checkedMessage.length;
      this.checkAll = checkedCount === this.messageData.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.messageData.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-divider--horizontal {
  margin: 18px 0;
}

.main {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto 100px;
  box-sizing: border-box;
  /* padding: 0 10px; */
  min-height: calc(100vh - 320px - 530px - 140px);
}

.message-list-container {
  // position: relative;
  // padding-top: 52px;
  // padding-bottom: 44px !important;
  // height: 100%;
}
.message-detail {
  padding-right: 32px;
  margin-right: 20px;
  //margin-left: 32px;
  margin-left: 10px;
  padding-left: 20px;
  border-left: 1px dashed rgb(226, 226, 226);
  overflow: scroll;
  // max-height: 100%;

  // position: absolute;
  right: 0;
  bottom: 0;
}

.message-list {
}
.message-list .items {
  margin: 0;
  padding: 0;
  list-style: none;
}
.message-list .item {
  position: relative;
  border-top: 1px solid #ededed;
}

.message-list .item:hover {
  background-color: #ededed;
}

.message-item-content {
  position: relative;
  padding-right: 0;
  padding-left: 16px;
  color: #999;
  cursor: default;
}

.message-item-content.new {
  color: #333;
}

.message-item-content.new:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  margin-top: -3px;
  width: 4px;
  height: 4px;
  background-color: #fc5043;
  border-radius: 50%;
}

.message-item-content h5 {
  font-size: 14px;
  margin-bottom: 10px;
}

.message-item-content i {
  display: block;
  color: #8a8e99;
  line-height: 1;
  font-size: 12px;
  font-style: normal;
}

.message-list .items .item .destroy {
  display: none;
  position: absolute;
  right: 10px;
  cursor: pointer;
}

.message-list .items .item:hover .destroy {
  display: block;
}

/****  */
.message-title h4 {
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}

.message-info {
  margin-top: 10px;
  margin-bottom: 10px;

  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}

.message-content {
  word-break: break-word;
  font-size: 18px;
  margin-top: 32px;
}
</style>
